// @ts-nocheck
import styled from 'styled-components';
import colors from '../../../styles/colors';

const GenericRenderContainerSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // se ci sono props width, width: props.width
    width: ${props => props.width ? props.width : '70%'};
    padding: ${props => props.padding ? props.padding : '0'};
    margin: 30px auto 10px auto;
    background-color: ${colors.bgColorBlack2};
    border-radius: 8px;
    border-top: 2px solid rgba(163, 27, 27, 0.4);

    & p.info-section {
        font-size: 14px;
        font-weight: 500;
        color: white;
        margin: 10px 0;
        padding: 0;
        text-align: center;
        width: 80%;
        font-style: italic;
        font-family: CameronSansMedium;
    }
`;

export default GenericRenderContainerSection;